import "./Order.css";

const OrderTracking = () => {
  return (
    <div className="order-page">
      <div className="order-container">
        {/* LEFT */}
        <div className="order-left">
          <h2>Track Your Order</h2>

          <div className="order-card status-header">
            <div>
              <strong>Order ID: <span className="link">#NX-10245</span></strong>
              <span>Placed on 16 Jan 2026</span>
            </div>
            <span className="badge">In Transit</span>
          </div>

          <div className="order-card">
            <h4>Order Status</h4>

            <div className="track-step completed">
              <div className="track-icon">✓</div>
              <div>
                <strong>Order Confirmed</strong>
                <span>16 Jan 2026, 10:45 AM</span>
              </div>
            </div>

            <div className="track-step completed">
              <div className="track-icon">📦</div>
              <div>
                <strong>Packed</strong>
                <span>16 Jan 2026, 2:30 PM</span>
              </div>
            </div>

            <div className="track-step active">
              <div className="track-icon">🚚</div>
              <div>
                <strong>In Transit</strong>
                <span>Expected delivery in 2–3 days</span>
              </div>
            </div>

            <div className="track-step">
              <div className="track-icon">🏠</div>
              <div>
                <strong>Delivered</strong>
                <span>Pending</span>
              </div>
            </div>
          </div>

          <div className="order-card">
            <h4>Product</h4>
            <div className="order-product">
              <img src="/images/product.jpg" alt="" />
              <div className="order-info">
                <strong>Address Here</strong>
                <span>P/N: AP-N716 | SKU: 320689</span>
              </div>
              <strong>₹ 249.00</strong>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="order-right">
          <div className="order-card">
            <h4>Order Summary</h4>
            <div className="summary-row">
              <span>Subtotal</span>
              <span>₹ 249.00</span>
            </div>
            <div className="summary-row">
              <span>Shipping</span>
              <span className="success">Free</span>
            </div>
            <div className="summary-total">
              <span>Total</span>
              <span>₹ 249.00</span>
            </div>
            <button className="outline-btn">Need Help?</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderTracking;
